import React from 'react'
import { faAngleLeft, faAngleRight } from '@fortawesome/free-solid-svg-icons'
import ProfileSection from 'app/common/pixel-menu/_comp/ProfileSection'
import moment from 'moment'
import {
  DcBreadcrumbs,
  DcButton,
  DcFlexBox,
  PixelFactoryContext,
  PixelIcon,
  PixelPageContainer,
  Section,
  SectionContent,
} from 'pixel-base'
import styled from 'styled-components'

import { getCourierReportsByYear } from 'utils/api-routes.util'

import MonthlyPaymentReport from './components/MonthlyPaymentReport'
import { IPixelFactory } from '../../../../decl.d'

const months = [
  {
    title: 'January',
    value: 'January',
  },
  {
    title: 'February',
    value: 'February',
  },
  {
    title: 'March',
    value: 'March',
  },
  {
    title: 'April',
    value: 'April',
  },
  {
    title: 'May',
    value: 'May',
  },
  {
    title: 'June',
    value: 'June',
  },
  {
    title: 'July',
    value: 'July',
  },
  {
    title: 'August',
    value: 'August',
  },
  {
    title: 'September',
    value: 'September',
  },
  {
    title: 'October',
    value: 'October',
  },
  {
    title: 'November',
    value: 'November',
  },
  {
    title: 'December',
    value: 'December',
  },
]

const breadcrumbs = [
  {
    name: 'Monthly Payments',
    active: true,
  },
]

const PaymentsMonthWise = () => {
  const monthlyReportRef = React.useRef()
  const [selectedYear, setSelectedYear] = React.useState(
    moment().format('YYYY'),
  )
  const [reports, setReports] = React.useState<any>([])
  const { showLoader, hideLoader } =
    React.useContext<IPixelFactory>(PixelFactoryContext)
  React.useEffect(() => {
    getAllReports()
  }, [selectedYear])

  const getAllReports = () => {
    showLoader(monthlyReportRef)
    getCourierReportsByYear(selectedYear).subscribe((res: any) => {
      setReports(res.response.data)
      hideLoader(monthlyReportRef)
    })
  }

  const getMonthReport = (month) => {
    const report = reports.find((report) => report.name === month)
    return report ? report.summary : []
  }

  return (
    <>
      <DcFlexBox
        height="60px"
        fontSize="16px"
        style={{
          fontSize: '16px',
          padding: '8px 0px',
          borderBottom: '1px solid #e5e5e5',
        }}
      >
        <DcFlexBox
          justifyContent="space-between"
          alignItems="center"
          padding=".5rem 20px"
        >
          <DcBreadcrumbs fontSize="16px" data={breadcrumbs} />

          <ProfileSection />
        </DcFlexBox>
      </DcFlexBox>

      <PixelPageContainer
        style={{
          maxHeight: 'calc(100vh - 60px)',
          padding: '0px',
          overflow: 'hidden',
        }}
        height="calc(100vh - 60px)"
        className="monthly-report"
        ref={monthlyReportRef}
      >
        <Section style={{ padding: '0px' }}>
          <SectionContent style={{ padding: '0px', borderRadius: '0px' }}>
            <DcFlexBox
              justifyContent="flex-end"
              padding="5px 20px"
              height="auto"
            >
              <DcButton
                size="sm"
                variant="link"
                onClick={() => {
                  setSelectedYear(
                    moment(`01-01-${selectedYear}`)
                      .subtract(1, 'year')
                      .format('YYYY'),
                  )
                }}
              >
                <PixelIcon color="inherit" icon={faAngleLeft} />
              </DcButton>

              <DcButton variant="link" size="sm">
                {selectedYear}
              </DcButton>
              <DcButton
                size="sm"
                variant="link"
                disabled={selectedYear === moment().format('YYYY')}
                onClick={() => {
                  setSelectedYear(
                    moment(`01-01-${selectedYear}`)
                      .add(1, 'year')
                      .format('YYYY'),
                  )
                }}
              >
                <PixelIcon color="inherit" icon={faAngleRight} />
              </DcButton>
            </DcFlexBox>
          </SectionContent>
        </Section>
        <MonthsReports>
          {months.map((month, i) => (
            <MonthlyPaymentReport
              key={i}
              month={month}
              year={selectedYear}
              summary={getMonthReport(month.title)}
            />
          ))}
        </MonthsReports>
      </PixelPageContainer>
    </>
  )
}

const MonthsReports = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  /* grid-column-gap: 10px; */
  /* grid-row-gap: 10px; */
  grid-auto-columns: 1fr;
  grid-auto-rows: 1fr;
  height: calc(100vh - 101px);
  overflow: auto;
`

export default PaymentsMonthWise
